import { render, staticRenderFns } from "./AccountHolderExpenseDetail.vue?vue&type=template&id=5d64da39&scoped=true"
import script from "./AccountHolderExpenseDetail.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64da39",
  null
  
)

export default component.exports